/* unplugin-vue-components disabled */import { render } from "./jas.vue?vue&type=template&id=2436ebc4&scoped=true"
import script from "./jas.vue?vue&type=script&lang=js"
export * from "./jas.vue?vue&type=script&lang=js"

import "./jas.vue?vue&type=style&index=0&id=2436ebc4&lang=scss&scoped=true"
import "./jas.vue?vue&type=style&index=1&id=2436ebc4&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2436ebc4"]])

export default __exports__